export type PlanName = "Trial" | "Basic" | "Family" | "Pro";

export const PLAN_LIMITS: Record<PlanName, number> = {
  Trial: 1,
  Basic: 1,
  Family: 3,
  Pro: 8,
};

export const PLAN_PRICES: Record<Exclude<PlanName, "Trial">, number> = {
  Basic: 19.9,
  Family: 49.9,
  Pro: 79.9,
};

export const PLAN_FEATURES: Record<
  PlanName,
  { label: string; priceLabel: string; children: number; features: string[] }
> = {
  Trial: {
    label: "Trial",
    priceLabel: "Free for 3 days",
    children: 1,
    features: [
      "1 protected child",
      "AI threat & bullying scan",
      "Parent WhatsApp alerts",
      "QR device linking",
    ],
  },
  Basic: {
    label: "Basic",
    priceLabel: "₪19.90 / 30 days",
    children: 1,
    features: [
      "1 protected child",
      "Real-time AI message scan",
      "Instant parent alerts",
      "Basic protection reports",
    ],
  },
  Family: {
    label: "Family",
    priceLabel: "₪49.90 / 30 days",
    children: 3,
    features: [
      "Up to 3 children",
      "Advanced reports",
      "Group exclusion alerts",
      "Priority support",
    ],
  },
  Pro: {
    label: "Pro",
    priceLabel: "₪79.90 / 30 days",
    children: 8,
    features: [
      "Up to 8 children",
      "Custom filter rules",
      "Advanced analytics",
      "24/7 priority support",
    ],
  },
};

export function isPlanActive(plan?: {
  planName: string | null;
  expiredAt: Date | null;
} | null) {
  if (!plan?.planName || !plan.expiredAt) return false;
  return new Date(plan.expiredAt).getTime() > Date.now();
}
